<script>
import { reactive, computed } from 'vue'

var BaseChart = {
  props: {
    height: {
      type: Number,
      default: 80,
    },
    data: {
      type: Object,
      default: () => {},
    },
    options: {
      type: Object,
      default: () => {},
    },
    id: {
      type: String,
      default: () => {
        return `canvas_${Math.random()}_chart`
      },
    },
    title: String,
    scrollable: Boolean,
  },
  computed: {
    // this computed methods may be redeclared on child Charts
    // to process data and options before render chart
    dataReady: (vm) => vm.data,
    optionsReady: (vm) => vm.options,
  },
  methods: {
    // to be defined, if needed, on child components
    prepareData() {},
    prepareOptions() {},
    renderChart(type, data, options) {
      import('chart.js').then((ChartEngine) => {
        let ChartLib = ChartEngine.default || ChartEngine
        this.chart = new ChartLib(this.id, {
          type: type,
          data: data,
          options: options,
        })
      })
    },
    updateData(newData) {
      if (this.chart.height === 0 && this.height > 0) {
        this.chart.canvas.parentNode.style.height = this.height + 'px'
      }

      this.chart.canvas.parentNode.style.width = document.getElementById('reference-width').firstElementChild.offsetWidth - 20 + 'px'
      this.chart.data = newData
      this.chart.update()
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  directives: {
    scrollable: {
      inserted: (el, binding, vnode) => {
        if (!binding.value) return

        var wrapper = el.parentNode
        let canvas = el
        var vm = vnode.context
        let width,
          height = false

        let initCanvasWrapper = function() {
          height = canvas.attributes.height ? canvas.attributes.height.value : false
          width =
            document.getElementById('reference-width')?.firstElementChild &&
            document.getElementById('reference-width').firstElementChild.offsetWidth
              ? document.getElementById('reference-width').firstElementChild.offsetWidth - 20
              : false

          if (height && width) {
            wrapper.style = 'width: ' + width + 'px;'
            vm.$emit('wrapper-init', el.id)
          } else {
            setTimeout(initCanvasWrapper, 500)
          }
        }

        setTimeout(initCanvasWrapper, 500)
      },
    },
  },
  mounted() {
    this.renderChart(this.type, this.dataReady, this.optionsReady)
  },
}

export { BaseChart }
export default BaseChart
</script>
